import {MessageNotificationTypeEnum} from '@/services/api-clients';

export function messageNotificationTypeColorFilter(type: MessageNotificationTypeEnum): string[] {
  switch(type) {
    case MessageNotificationTypeEnum.VehicleRentMissingDigitalDocuments: return ['blue accent-1', 'blue--text text--accent-1'];
    case MessageNotificationTypeEnum.VehicleReservationCreated: return ['primary', 'primary--text'];
    case MessageNotificationTypeEnum.VehicleReservationCancelledByDriver: return ['error', 'error--text'];
    case MessageNotificationTypeEnum.SupportTicketCreated: return ['warning', 'warning--text'];
    case MessageNotificationTypeEnum.SupportTicketDriverMessage: return ['success', 'success--text'];
    case MessageNotificationTypeEnum.SupportTicketClosedByDriver: return ['grey', 'grey--text'];
    default: return ['', ''];
  }
}
